const PermissionStatus = {
  Granted: "GRANTED"};

export { PermissionStatus };
//# sourceMappingURL=permission-status.mjs.map
